module.exports = __webpack_public_path__ + "static/media/icon_arrow_R.a7de1089.svg";